
export enum Path {
  Home = '/landing',

  Home2 = '/home',
  Landing = '/',
  Landlord = '/landing/landlord',
  Lawyer = '/landing/lawyer',
  Agent = '/landing/agent',
  Realtor = '/landing/realtor',
  Team = '/team',
  Property = '/property',
  PropertyDetail = '/property/:id',

  About = '/about',
  ContactUs = '/contact',
  Blog = '/blog',
  BlogDetail = '/blog/:id',
  RentPage = '/rent',
  RentDetail = '/rent/:id',
  Listing = '/listing',

  Login = '/login',
  Otp = '/otp',
  Signup = '/signup',
  Buyer = '/signup/buyer',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password/:token',

  UserDashboard = '/user/dashboard',
  UserDealRoom = '/user/deal-room',
  UserDealRoomDetail = '/user/deal-room/:id',
  UserKyc = '/user/kyc',
  UserProperty = '/user/property',
  UserMessage = '/user/messages',
  UserSetting = '/user/settings',
  UserAddProperty = '/user/property/add',
  UserPropertyDetail = '/user/property/:id',
  UserEditProperty = '/user/property/edit/:id',

  UserManagementDetails = '/user/management-property/:id',
  UserNotifications = '/user/notifications',
  UserNotificationDetails = '/user/notifications/:id',


  AdminLogin = '/admin/login',
  AdminDashboard = '/admin/dashboard',
  AdminProperty = '/admin/properties',
  AdminUsers = '/admin/users',
  AdminSetting = '/admin/settings',
  AdminKycStatus = '/admin/kyc-status',
  AdminPropertyDetail = '/admin/properties/:id',
  AdminDealRoom = '/admin/deal-room',
  AdminDealRoomDetail = '/admin/deal-room/:id',

  Events = '/events',






}
